import { memo, useContext } from 'react';
import { useWatch } from 'react-hook-form';

import { useLanguage } from '@languages/index';
import TextArea from 'components/textArea';
import { CampaignFormContext } from 'pages/campaigns/campaignForm/campaignForm.context';
import { CampaignFormFieldWrapperProps } from '../formFields.types';
import CampaignFormField from '../../../../campaignFormFieldGroup/components/campaignFormField/campaignFormField';
import { MAX_LENGTH } from 'pages/campaigns/campaignForm/campaignForm.constants';

const DescriptionField = ({ elementIndex }: CampaignFormFieldWrapperProps) => {
  const language = useLanguage();
  const languageTexts = { ...language.pages.campaigns };
  const {
    campaignFormMethods: { register, control },
  } = useContext(CampaignFormContext);

  const description = useWatch({ control, name: 'description' });

  return (
    <CampaignFormField label={`${elementIndex}. ${languageTexts.campaign_form_brand_description_field_label}`}>
      <div className="flex flex-col gap-1">
        <TextArea
          register={register('description', {
            required: true,
            maxLength: MAX_LENGTH,
          })}
          placeholder={languageTexts.campaign_form_brand_description_field_placeholder(MAX_LENGTH)}
          bordered
          autoResize={true}
          inputStyle={{ display: 'block', minHeight: '83.52px' }}
        />
        <span className="text-xs text-gray-500">
          {languageTexts._create_max_length_indicator(description?.length || 0, MAX_LENGTH)}
        </span>
      </div>
    </CampaignFormField>
  );
};

export default memo(DescriptionField);
